import {
  ADD_NEWSPOST_LOADER,
  DELETE_NEWSPOST_LOADER,
  NEWS_POST_DATA,
  UPDATE_NEWSPOST_LOADER,
} from '../action/NewsPosts';

const initialState = {
  addNewsPostLoader: false,
  updateNewsPostLoader: false,
  deleteNewsPostLoader: false,
  NewsPosts: [],
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NEWSPOST_LOADER:
      return {
        ...state,
        addNewsPostLoader: action.payload,
      };
    case NEWS_POST_DATA:
      return {
        ...state,
        NewsPosts: action.payload,
      };
    case UPDATE_NEWSPOST_LOADER:
      return {
        ...state,
        updateNewsPostLoader: action.payload,
      };

    case DELETE_NEWSPOST_LOADER:
      return {
        ...state,
        deleteNewsPostLoader: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default ContentReducer;
